module.exports = {
    headers: {
        accept: 'application/json'
    },
    baseUrl: process.env.REACT_APP_BASE_URL
}
